// extracted by mini-css-extract-plugin
export default {"SkeletonBlock":"📚19-10-2_etLT","loading":"📚19-10-2JOsYT","pulsing":"📚19-10-2sRbq0"};